let state = {
  webSocketMsg: ''
}

//修改state
const mutations = {
  // 存储websocket推送的消息
  SET_WS_MSG: (state, msg) => {
    state.webSocketMsg = msg
  }
}
//获取state的状态
const getters = {
  webSocketMsg: state => state.user.webSocketMsg
}
// //提交异动mutations。 如果在接受块出现问题，可以把这个加上去看看
// const actions = {
//   webSockets({ commit }) {
//     commit('SET_WS_MSG', )
//   }
// }
export default { state, getters, mutations }
